import React, { useState, useEffect, useContext } from "react"
import { FirebaseContext } from '../Firebase'
import { organizeByType } from "../bookmark/utils/utils"
import StoriesExplore from "./StoriesExplore"
import CareersExplore from "./CareersExplore"
import CareersPersonalityExplore from "./CareersPersonalityExplore"
import SchoolsExplore from "./SchoolsExplore"
import MajorsExplore from "./MajorsExplore"
import CompaniesExplore from "./CompaniesExplore"
import VideosExplore from "./VideosExplore"
import { Dropdown } from "semantic-ui-react"
import { WingsEyebrow, WingsHeading } from "@wingspans-ui"

import { useQueryParam, StringParam, JsonParam, BooleanParam } from "use-query-params";

import "semantic-ui-css/components/dropdown.min.css"
import "semantic-ui-css/components/search.min.css"
import "semantic-ui-css/components/transition.min.css"
import "semantic-ui-css/components/label.min.css"
import "semantic-ui-css/components/icon.min.css"
import { FormattedMessage, useIntl } from "react-intl"

const ExploreCategoryToggle = props => {
  const { heading } = props
  const { locale } = useIntl()
  const { profile } = useContext(FirebaseContext)
  const [selectState, setSelectState] = useState('People')
  const [saved, setSaved] = useState(null)

  const [categoryQuery, setCategoryQuery] = useQueryParam("category", StringParam)
  const [queryFilters, setQueryFilters] = useQueryParam("queryFilters", JsonParam)
  const [showSavedQuery, setShowSavedQuery] = useQueryParam("showSaved", BooleanParam)
  const [personalityQuery, setPersonalityQuery] = useQueryParam("personality", BooleanParam)

  useEffect(() => {
    if (profile && profile.bookmarks) {
      const bookmarks = organizeByType(profile.bookmarks)
      setSaved(bookmarks)
    }
  }, [profile])

  const options = [
    {
      key: "Personality", text: <FormattedMessage
        id="algolia-toggle-dropdown-careers"
        defaultMessage="Careers"
      />, value: "PersonalityCareers"
    },
    {
      key: "People", text: <FormattedMessage
        id="algolia-toggle-dropdown-people"
        defaultMessage="People"
      />, value: "People"
    },
    {
      key: "Careers", text: <FormattedMessage
        id="algolia-toggle-dropdown-careers"
        defaultMessage="Careers"
      />, value: "Careers"
    },
    {
      key: "Schools", text: <FormattedMessage
        id="algolia-toggle-dropdown-schools"
        defaultMessage="Schools"
      />, value: "Schools"
    },
    {
      key: "Majors", text: <FormattedMessage
        id="algolia-toggle-dropdown-majors"
        defaultMessage="Majors"
      />, value: "Majors"
    },
    {
      key: "Companies", text: <FormattedMessage
        id="algolia-toggle-dropdown-companies"
        defaultMessage="Featured Employers"
      />, value: "Companies"
    },
    {
      key: "Videos", text: <FormattedMessage
        id="algolia-toggle-dropdown-videos"
        defaultMessage="Videos"
      />, value: "Videos"
    },
  ]

  /**
   * Generate a valid filter list from saved items.
   *
   * @param {string} type
   * @returns {null|string}
   */
  const getFilters = type => {
    if (saved && saved.hasOwnProperty(type)) {
      return saved[type].join(" OR ")
    } else {
      return null
    }
  }

  // PersonalityCareers is temporarily included in the dropdown but hidden via CSS.
  // First item will be invisible from dropdown
  //
  //.explore-sortby.first-hidden{
  // div[role="option"]:first-of-type{
  //  display: none !important;
  //  }
  //}

  const content = {
    PersonalityCareers: <CareersPersonalityExplore classContext={'careers'} />,
    People: <StoriesExplore classContext={'stories'} filterList={getFilters('stories') || 'false_attribute:false'} />,
    Careers: <CareersExplore classContext={'careers'} filterList={getFilters('careers') || 'false_attribute:false'} />,
    Schools: <SchoolsExplore classContext={'schools'} filterList={getFilters('schools') || 'false_attribute:false'} />,
    Majors: <MajorsExplore classContext={'majors'} filterList={getFilters('majors') || 'false_attribute:false'} />,
    Companies: <CompaniesExplore classContext={'companies'} filterList={getFilters('companies') || 'false_attribute:false'} />,
    Videos: <VideosExplore classContext={'stories'} filterList={getFilters('stories') || 'false_attribute:false'} />
  }

  function changeHandler(e, data) {
    e.preventDefault()
    setSelectState(data.value);

    setCategoryQuery(data.value)
    setQueryFilters(undefined)
    setShowSavedQuery(undefined)
  }

  useEffect(() => {
    if (categoryQuery === "Careers" && personalityQuery === true) {
      setSelectState('PersonalityCareers')
    } else {
      setSelectState(categoryQuery || 'People')
    }
  }, [categoryQuery, personalityQuery])

  return (
    <section className="explore">
      <div className="explore-content">
        <div className="explore-sortby first-hidden">
          <span
            style={{
              fontWeight: "bold",
              marginBottom: ".5rem",
              display: "block",
              color: "#565656",
            }}
          >
            <FormattedMessage
              id="algolia-toggle-explore-categories"
              defaultMessage="Explore Categories"
            />
          </span>

          <Dropdown
            value={selectState}
            fluid
            required
            selection
            icon="chevron down"
            options={options}
            onChange={changeHandler}
            className="ais-MenuSelect"
            upward={false}
          />
        </div>
        <header className="explore-header w-text-center">
          <WingsEyebrow as="p">
            <FormattedMessage id="algolia-toggle-eyebrow" defaultMessage="EXPLORE" />
          </WingsEyebrow>
          <WingsHeading level={1}>
            {options.find(option => option.value === selectState)?.text ?? heading}
          </WingsHeading>
        </header>
        {/* key combines locale and category so the explore component fully remounts on either change, resetting search state and placeholder */}
        {React.cloneElement(content[selectState], { key: `${locale}-${selectState}` })}
      </div>
    </section>
  )
}

export default ExploreCategoryToggle
